import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageId } from './shared/utilities/pageids.enum';
import { TitleSeoResolver } from './shared/services/title.resolver';
import { EventArticleResolver } from './shared/services/event-article.resolver';
import { ArticleResolver } from './shared/services/article.resolver';
import { WhitepaperArticleResolver } from './shared/services/whitepaper-article.resolver';
import { WebinarArticleResolver } from './shared/services/webinar-article.resolver';
import { HiddenWhitepaperArticleResolver } from './shared/services/hidden-whitepaper-article.resolver';
import { ExternalRedirectResolver } from './shared/utilities/external-redirect.resolver';
import { appDownloadComponent } from './features/appDownload/appDownload';

export const routes: Routes = [
  { path: 'about-us/resources/blog/article/undefined/', redirectTo: '/', pathMatch: 'full' },
  { path: 'countries/africa/malawi/', redirectTo: '/', pathMatch: 'full' },
  {
    path: 'aboutverto/intentuk',
    loadComponent: () =>
      import('./features/landingIntentUK/landingIntentUK.component').then(
        mod => mod.landingIntentUKComponent
      ),
    data: {
      params: {
        contentType: PageId.landingPage,
        fieldsId: PageId.landingIntentUK,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'aboutverto/remitfinder',
    loadComponent: () =>
      import('./features/Remitfinder/Remitfinder.component').then(
        mod => mod.RemitfinderComponent
      ),
    data: {
      params: { contentType: PageId.landingPage, fieldsId: PageId.remitfinder },
    },
    resolve: { seo: TitleSeoResolver },
  },

  {
    path: 'business-accounts',
    loadComponent: () =>
      import('./features/business-accounts/business-accounts.component').then(
        mod => mod.BusinessAccountsComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.businessAcc,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/local-account',
    loadComponent: () =>
      import(
        './features/solutions/collect/local-account/local-account.component'
      ).then(mod => mod.LocalAccountComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.localAccountPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/global-account',
    loadComponent: () =>
      import(
        './features/solutions/collect/global-account/global-account.component'
      ).then(mod => mod.GlobalAccountComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.globalAccountPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/multi-currency-wallet',
    loadComponent: () =>
      import(
        './features/solutions/collect/multi-currency-wallet/multi-currency-wallet.component'
      ).then(mod => mod.MultiCurrencyWalletComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.multiCurrencyWallet,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/international-payments',
    loadComponent: () =>
      import(
        './features/solutions/collect/international-payments/international-payment.component'
      ).then(mod => mod.InternatiionalPaymentsComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.internationalPaymentsPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/v-pay',
    loadComponent: () =>
      import('./features/solutions/collect/v-pay/v-pay.component').then(
        mod => mod.VPayComponent
      ),
    data: {
      params: { contentType: PageId.solutionsPage, fieldsId: PageId.vPayPage },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/local-payments',
    loadComponent: () =>
      import(
        './features/solutions/collect/local-payments/local-payments.component'
      ).then(mod => mod.LocalPaymentsComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.LocalPaymentsPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/invoice-payments',
    loadComponent: () =>
      import('./features/invoice-payments/invoice-payments.component').then(
        mod => mod.InvoicePaymentsComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.invoicePayments,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/virtual-card',
    loadComponent: () =>
      import(
        './features/solutions/pay/virtual-card/virtual-card.component'
      ).then(mod => mod.VirtualCardComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsVirtualCard,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/physical-card',
    loadComponent: () =>
      import(
        './features/solutions/pay/physical-card/physical-card.component'
      ).then(mod => mod.PhysicalCardComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsPhysicalCard,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/treasury-management',
    loadComponent: () =>
      import(
        './features/solutions/convert/advanced-liquidity/advanced-liquidity.component'
      ).then(mod => mod.AdvancedLiquidityComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsConvertAdvancedLiquidity,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/reserve',
    loadComponent: () =>
      import('./features/solutions/collect/reserve/reserve.component').then(
        mod => mod.ReserveComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsReservePage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'business-accounts/bulk-payments',
    loadComponent: () =>
      import('./features/atlas/mass-payouts/mass-payouts.component').then(
        mod => mod.AtlasMassPayoutsComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.MassPayoutsPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'fx',
    loadComponent: () =>
      import(
        './features/treasury-management/treasury-management.component'
      ).then(mod => mod.TreasuryManagementV2Component),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.treasuryManagement,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'fx/auto-exchange',
    loadComponent: () =>
      import(
        './features/solutions/convert/auto-exchange/auto-exchange.component'
      ).then(mod => mod.AutoExchangeComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsAutoExchange,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'fx/marketplace',
    loadComponent: () =>
      import(
        './features/solutions/convert/marketplace/marketplace.component'
      ).then(mod => mod.MarketplaceComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsConvertMarketplace,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'fx/spot-fx',
    loadComponent: () =>
      import('./features/solutions/convert/spot-fx/spot-fx.component').then(
        mod => mod.SpotFxComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsSpotFx,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'fx/otc-fx',
    loadComponent: () =>
      import('./features/solutions/convert/otc/otc.component').then(
        mod => mod.OTCFXComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsOTCPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },

  {
    path: 'atlas',
    loadComponent: () =>
      import('./features/atlas/atlas.component').then(
        mod => mod.AtlasComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.atlasLandingPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'atlas/collections-and-accounts',
    loadComponent: () =>
      import(
        './features/atlas/embedded-collections/embedded-collections.component'
      ).then(mod => mod.EmbeddedCollectionsComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsEmbeddedCollectionsPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'atlas/apis',
    loadComponent: () =>
      import('./features/atlas/api/api.component').then(
        mod => mod.AtlasAPIsComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.solutionsAPIsPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  

  // { path: 'invoice-payments', component: InvoicePaymentsComponent, data: { params: { contentType: PageId.solutionsPage, fieldsId: PageId.invoicePayments } }, resolve: { seo: TitleSeoResolver } },
  {
    path: 'core-api',
    loadComponent: () =>
      import('./features/core-apis/core-apis.component').then(
        mod => mod.CoreApisComponent
      ),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.coreApiPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },

  {
    path: 'pricing',
    loadComponent: () =>
      import('./features/pricing/pricing.component').then(
        mod => mod.PricingComponent
      ),
    data: { params: { contentType: PageId.pricingPage } },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'pricing/kenya',
    loadComponent: () =>
      import('./features/pricing-kenya/pricing-kenya.component').then(
        mod => mod.PricingKenyaComponent
      ),
    data: { params: { contentType: PageId.pricingPage } },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'pricing/south-africa',
    loadComponent: () =>
      import(
        './features/pricing-south-africa/pricing-south-africa.component'
      ).then(mod => mod.PricingSouthAfricaComponent),
    data: { params: { contentType: PageId.pricingPage } },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'pricing/nigeria',
    loadComponent: () =>
      import('./features/pricing-nigeria/pricing-nigeria.component').then(
        mod => mod.PricingNigeriaComponent
      ),
    data: { params: { contentType: PageId.pricingPage } },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'pricing/united-states',
    loadComponent: () =>
      import(
        './features/pricing-united-states/pricing-united-states.component'
      ).then(mod => mod.PricingUnitedStatesComponent),
    data: { params: { contentType: PageId.pricingPage } },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'pricing/united-kingdom',
    loadComponent: () =>
      import(
        './features/pricing-united-kingdom/pricing-united-kingdom.component'
      ).then(mod => mod.PricingUnitedKingdomComponent),
    data: { params: { contentType: PageId.pricingPage } },
    resolve: { seo: TitleSeoResolver },
  },

  {
    path: 'invoice-payments/payment-links',
    loadComponent: () =>
      import(
        './features/solutions/collect/payment-links/payment-links.component'
      ).then(mod => mod.PaymentLinksComponent),
    data: {
      params: {
        contentType: PageId.solutionsPage,
        fieldsId: PageId.paymentLinksPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },

  {
    path: 'solutions/company-size/scale-up',
    loadComponent: () =>
      import(
        './features/solutions/company-size/scale-up/scale-up.component'
      ).then(mod => mod.ScaleupComponent),
    data: {
      params: {
        contentType: PageId.companySizes,
        fieldsId: PageId.scaleupPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'solutions/company-size/start-up',
    loadComponent: () =>
      import(
        './features/solutions/company-size/start-up/start-up.component'
      ).then(mod => mod.startupComponent),
    data: {
      params: {
        contentType: PageId.companySizes,
        fieldsId: PageId.startupPage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'solutions/company-size/enterprises',
    loadComponent: () =>
      import(
        './features/solutions/company-size/enterprise/enterprise.component'
      ).then(mod => mod.EnterpriseComponent),
    data: {
      params: {
        contentType: PageId.companySizes,
        fieldsId: PageId.enterprisePage,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },

  {
    path: 'about-us/company/about-us',
    loadComponent: () =>
      import('./features/company/about/about.component').then(
        mod => mod.AboutComponent
      ),
    data: {
      params: {
        contentType: PageId.companyPage,
        fieldsId: PageId.companyAbout,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/company/founders-associate-program',
    loadComponent: () =>
      import('./features/company/graduate-scheme/graduate.component').then(
        mod => mod.GraduateComponent
      ),
    data: {
      params: {
        contentType: PageId.companyPage,
        fieldsId: PageId.companyGraduateScheme,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/company/careers',
    loadComponent: () =>
      import('./features/company/careers/careers.component').then(
        mod => mod.CareersComponent
      ),
    data: {
      params: {
        contentType: PageId.companyPage,
        fieldsId: PageId.companyCareers,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/company/partners',
    loadComponent: () =>
      import('./features/company/partners/partners.component').then(
        mod => mod.PartnersComponent
      ),
    data: {
      params: {
        contentType: PageId.companyPage,
        fieldsId: PageId.companyPartners,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/company/licences',
    loadComponent: () =>
      import('./features/company/licences/licences.component').then(
        mod => mod.LicencesComponent
      ),
    data: {
      params: {
        contentType: PageId.companyPage,
        fieldsId: PageId.companyLicences,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/media-and-events/events',
    loadComponent: () =>
      import('./features/company/resources/events/events.component').then(
        mod => mod.EventsComponent
      ),
    data: { params: { contentType: PageId.eventsPage } },
    resolve: { seo: TitleSeoResolver },
  },
  
  {
    path: 'about-us/media-and-events/customer-stories',
    loadComponent: () =>
      import('./features/company/customers/customers.component').then(
        mod => mod.CustomersComponent
      ),
    data: { params: { contentType: PageId.customersLandingPage } },
    resolve: { seo: TitleSeoResolver },
  },
  
  {
    path: 'about-us/media-and-events/newsroom',
    loadComponent: () =>
      import('./features/company/resources/newsroom/newsroom.component').then(
        mod => mod.NewsroomComponent
      ),
    data: { params: { contentType: PageId.newsroomPage } },
    resolve: { seo: TitleSeoResolver },
  },
  
  {
    path: 'about-us/legal/terms-of-service',
    loadComponent: () =>
      import(
        './features/company/terms-of-service/terms-of-service.component'
      ).then(mod => mod.TermsOfServiceComponent),
    data: {
      params: {
        contentType: PageId.otherCompanyPages,
        fieldsId: PageId.termsAndConditions,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/legal/us-licence',
    loadComponent: () =>
      import(
        './features/company/us-legal/us-legal.component'
      ).then(mod => mod.UsLegalComponent),
    data: {
      params: {
        contentType: PageId.otherCompanyPages,
        fieldsId: PageId.usLicenses,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/legal/canada/terms-of-service',
    loadComponent: () =>
      import(
        './features/company/us-legal/us-legal.component'
      ).then(mod => mod.UsLegalComponent),
    data: {
      params: {
        contentType: PageId.otherCompanyPages,
        fieldsId: PageId.canadaTermsOfService,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/legal/privacy-policy',
    loadComponent: () =>
      import('./features/company/privacy-policy/privacy-policy.component').then(
        mod => mod.PrivacyPolicyComponent
      ),
    data: {
      params: {
        contentType: PageId.otherCompanyPages,
        fieldsId: PageId.privacyPolicy,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/legal/cookie-policy',
    loadComponent: () =>
      import('./features/company/cookie-policy/cookie-policy.component').then(
        mod => mod.CookiePolicyComponent
      ),
    data: {
      params: {
        contentType: PageId.otherCompanyPages,
        fieldsId: PageId.cookiePolicy,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/legal/modern-slavery-statement',
    loadComponent: () =>
      import('./features/company/Modern-Slavery-Statement/modern-slavery-statement.component').then(
        mod => mod.ModernSlaveryStatementComponent
      ),
    data: {
      params: {
        contentType: PageId.otherCompanyPages,
        fieldsId: PageId.modernSlaveryStatement,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/resources/support',
    loadComponent: () =>
      import('./features/company/resources/support/support.component').then(
        mod => mod.ContactComponent
      ),
    data: {
      params: {
        contentType: PageId.companyPage,
        fieldsId: PageId.companyResourcesSupportContactForm,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/resources/sitemap',
    loadComponent: () =>
      import('./features/company/sitemap/sitemap.component').then(
        mod => mod.SitemapComponent
      ),
    resolve: {},
  },
  {
    path: 'about-us/resources/blog',
    loadComponent: () =>
      import('./features/company/blog/blog.component').then(
        mod => mod.BlogComponent
      ),
    data: { params: { contentType: PageId.blogPage } },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/resources/whitepapers-and-reports',
    loadComponent: () =>
      import(
        './features/company/resources/white-papers-and-reports/white-papers-and-reports.component'
      ).then(mod => mod.WhitePapersAndReportsComponent),
    data: { params: { contentType: PageId.whitepapersAndReports } },
    resolve: { seo: TitleSeoResolver },
  },
  
  {
    path: 'about-us/media-and-events/webinars-and-podcasts',
    loadComponent: () =>
      import(
        './features/company/resources/webinars-and-podcasts/webinars-and-podcasts.component'
      ).then(mod => mod.WebinarsAndPodcastsComponent),
  },
  {
    path: 'coverage/currencies',
    loadComponent: () =>
      import('./features/coverage/currencies/currencies.component').then(
        mod => mod.CurrenciesComponent
      ),
    data: {
      params: {
        contentType: PageId.coveragePage,
        fieldsId: PageId.coverageCurrenciesAlt,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'coverage/countries',
    loadComponent: () =>
      import('./features/coverage/geographies/geographies.component').then(
        mod => mod.GeographiesComponent
      ),
    data: {
      params: {
        contentType: PageId.coveragePage,
        fieldsId: PageId.coverageGeographies,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/company/refer',
    loadComponent: () =>
      import('./features/solutions/refer/refer.component').then(
        mod => mod.ReferComponent
      ),
    data: {
      params: { contentType: PageId.solutionsPage, fieldsId: PageId.referPage },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'country/kenya',
    loadComponent: () =>
      import('./features/countryKenya/countryhome.component').then(
        mod => mod.CountryHomeComponent
      ),
    data: {
      params: {
        contentType: PageId.companyPage,
        fieldsId: PageId.countryKenya,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'country/nigeria',
    loadComponent: () =>
      import('./features/countryNigeria/countryhomenigeria.component').then(
        mod => mod.CountryHomeNigeriaComponent
      ),
    data: {
      params: {
        contentType: PageId.companyPage,
        fieldsId: PageId.countryNigeria,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'country/southafrica',
    loadComponent: () =>
      import('./features/countrySouthAfrica/countryhome.component').then(
        mod => mod.CountryHomeComponent
      ),
    data: {
      params: { contentType: PageId.companyPage, fieldsId: PageId.countrySA },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'country/us',
    loadComponent: () =>
      import('./features/countryKenya/countryhome.component').then(
        mod => mod.CountryHomeComponent
      ),
    data: {
      params: { contentType: PageId.companyPage, fieldsId: PageId.countryUS },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'country/uk',
    loadComponent: () =>
      import('./features/countryUk/countryhome.component').then(
        mod => mod.CountryHomeComponent
      ),
    data: {
      params: { contentType: PageId.companyPage, fieldsId: PageId.countryUK },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-verto/financial-times',
    loadComponent: () =>
      import('./features/campaign/south-africa/southAfrica.component').then(
        mod => mod.SouthAfricaComponent
      ),
    data: {
      params: { contentType: PageId.companyPage, fieldsId: PageId.financialTimesCampaign },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/media-and-events/newsroom/article/:id',
    loadComponent: () =>
      import(
        './features/company/resources/newsroom/news-article/news-article.component'
      ).then(mod => mod.NewsArticleComponent),
  },
  {
    path: 'campaign/:whitepaperid',
    loadComponent: () =>
      import('./features/hiddenWhitepaper/hiddenWhitepaper.component').then(
        mod => mod.WhitepaperArticleComponent
      ),
    data: { param: { contentType: PageId.companyPage } },
    resolve: { seo: HiddenWhitepaperArticleResolver },
  },
  {
    path: 'about-us/media-and-events/events/:detail/:eventdetail',
    loadComponent: () =>
      import(
        './features/company/resources/events/events-article/events-article.component'
      ).then(mod => mod.EventsArticleComponent),
    resolve: { articleContent: EventArticleResolver },
  },
  {
    path: 'about-us/media-and-events/customer-stories/:casestudyID',
    loadComponent: () =>
      import(
        './features/company/customers/case-study/case-study.component'
      ).then(mod => mod.CaseStudyComponent),
    data: { params: { contentType: PageId.customerStoryArticlePage } },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'about-us/resources/blog/article/:id',
    loadComponent: () =>
      import('./features/company/blog/article/article.component').then(
        mod => mod.ArticleComponent
      ),
    resolve: { articleContent: ArticleResolver },
  },
  {
    path: 'about-us/resources/whitepapers-and-reports/:whitepaperid',
    loadComponent: () =>
      import(
        './features/company/resources/white-papers-and-reports/whitepaper-article/whitepaper-article.component'
      ).then(mod => mod.WhitepaperArticleComponent),
    resolve: { articleContent: WhitepaperArticleResolver },
  },
  {
    path: 'about-us/media-and-events/webinars-and-podcasts/:webinararticleid',
    loadComponent: () =>
      import(
        './features/company/resources/webinars-and-podcasts/webinars-article/webinars-article.component'
      ).then(mod => mod.WebinarsArticleComponent),
    resolve: { articleContent: WebinarArticleResolver },
  },
  {
    path: 'solutions/:casetype/:caseid',
    loadComponent: () =>
      import('./features/usecases/usecases.component').then(
        mod => mod.UsecasesComponent
      ),
    data: { params: { contentType: PageId.useCasesPage } },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'coverage/currencies/:continent/:currencyname',
    loadComponent: () =>
      import(
        './features/coverage/currencies/country-currency/country-currency.component'
      ).then(mod => mod.CountryCurrencyComponent),
    data: {
      params: {
        contentType: PageId.coveragePage,
        fieldsId: PageId.coverageCurrencyKenyanShillings,
      },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: 'coverage/countries/:continent/:countryname',
    loadComponent: () =>
      import(
        './features/coverage/geographies/country-detail/country-detail.component'
      ).then(mod => mod.CountryDetailComponent),
  },
  {
    path: 'activate',
    loadComponent: () =>
      import('./features/solutions/pay/corporate-card-activate/card-activate.component').then(
        mod => mod.CardActivateComponent
      )
  },
  {
    path: '404',
    loadComponent: () =>
      import('./not-found/not-found.component').then(
        mod => mod.NotFoundComponent
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./features/newhomepage/newhomepage.component').then(
        mod => mod.NewhomepageComponent
      ),
    data: {
      params: { contentType: PageId.landingPage, fieldsId: PageId.newhomepage },
    },
    resolve: { seo: TitleSeoResolver },
  },
  { path: 'download', 
    component: appDownloadComponent,
    resolve: {
      redirect: ExternalRedirectResolver
    }
  },
  {
    path: '**',
    loadComponent: () =>
      import('./not-found/not-found.component').then(
        mod => mod.NotFoundComponent
      ),
  },
];

// @NgModule({
//   imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled'})],
//   exports: [RouterModule]
// })
// export class AppRoutingModule { }

export const aeRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/UAE-HomePage/UAE-HomePage.component').then(
        mod => mod.UAEHomepageComponent
      ),
    data: {
      params: { contentType: PageId.landingPage, fieldsId: PageId.homepageUAE },
    },
    resolve: { seo: TitleSeoResolver },
  },
  {
    path: '404',
    loadComponent: () =>
      import('./not-found/not-found.component').then(
        mod => mod.NotFoundComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./redirect-component/redirect-component.component').then(
        mod => mod.RedirectComponentComponent
      ),
  },
];
